import * as React from "react";
import { Skeleton } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const ProductBlockImagePlaceholder = ({ src, alt }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Skeleton, { height: "100%", width: "100%", "aria-label": getLabel("common.loadingText") }, /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", rx: "5", fill: "currentColor" })), /* @__PURE__ */ React.createElement("noscript", null, /* @__PURE__ */ React.createElement("img", { src, alt, width: "100%", height: "100%" })));
};
export {
  ProductBlockImagePlaceholder
};
//# sourceMappingURL=ProductBlockImagePlaceholder.js.map
